var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notificationDetails warp" }, [
    _c(
      "div",
      { staticClass: "head" },
      [
        _c("router-link", { attrs: { to: "/message" } }, [
          _c("div", { staticClass: "mar-right-10" }, [_vm._v("消息中心")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "arrow" }),
        _vm._v(" "),
        _c("div", { staticClass: "mar-right-10" }, [_vm._v("公告详情")])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "messageDetail"
      },
      [
        _c("h1", [_vm._v(_vm._s(_vm.detail.noticeTitle))]),
        _vm._v(" "),
        _c("div", { staticClass: "date" }, [
          _vm._v(_vm._s(_vm.detail.createTime))
        ]),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c("div", {
          staticClass: "messageInfo",
          domProps: { innerHTML: _vm._s(_vm.detail.noticeContent) }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-69e8d3cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-69e8d3cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/messageCenter/notificationDetails.vue
// module id = null
// module chunks = 